<template>
	<div>
		<div v-if="loading">
			{{ $t('screening.finalize.loading.label') }}
		</div>
		<div v-if="!loading">
			<div v-if="readyToSend">
				{{ $t('screening.finalize.sending.0') }}
				<!-- <button :disabled="sendingInvitation" v-on:click="sendInvitation">
					<span v-if="!sendingInvitation">{{ $t('screening.finalize.sendinvitation.button') }}</span>
					<span v-if="sendingInvitation">{{ $t('screening.finalize.sending.button') }}</span>
				</button> -->
			</div>
			<div v-else>
				<OrderProcess :product="1" v-on:completed="completed()" :params="getScreeningParams" />
			</div>
		</div>
	</div>
</template>

<script>
	import Vue from 'vue';

    import {mapGetters} from 'vuex';
    import OrderProcess from '../../components/OrderProcess';

	export default {
		data: () => ({
			loading: true,
			readyToSend: false,
			sendingInvitation: false
		}),
		components: {
			OrderProcess
		},
		computed: {
			...mapGetters([
				'getToken',
				'getCreditCardRedirection'
			]),
			getScreeningParams() {
				return {
					'invitationId': this.$route.params.id
				}
			}
		},
		watch: {
			readyToSend: {
                handler: function(val, oldVal) {
                	this.sendInvitation();
                },
                deep: true
            }
		},
		methods: {
			completed() {
				this.$router.go(0);
			},
			sendInvitation() {
				var self = this;
				this.sendingInvitation = true;
				axios({
					method: 'GET',
					url: window.config.apiUrl + 'api/invitation/' + this.$route.params.id + '/send',
					cancelToken: window.AuthorizationCancelSource.token,

				}).then(response => {
					// self.fetchInvitation();
					if (response.data.wasSent) {
                    	self.$store.commit('setSuccessBarMessage', self.$t('successbar.screenings.sent.message'));
                    }
                    this.$router.push('/receipt/screening/'+this.$route.params.id);
				}).finally(e => {
					self.sendingInvitation = false;
				});
			},
			fetchInvitation() {
				this.loading = true;
				this.readyToSend = false;
				var self = this;
				axios({
					method: 'GET',
					url: window.config.apiUrl + 'api/invitation/' + this.$route.params.id,
					cancelToken: window.AuthorizationCancelSource.token,
				}).then(response => {
					self.$store.commit('setCreditCardRedirection', '/screenings/'+this.$route.params.id+'/send');
					self.loading = false;
					self.readyToSend = response.data.readyToSend;
				});
			}
		},
		created() {
			this.fetchInvitation();
		}
	}
</script>
